module.exports = __webpack_public_path__ + "media/images/filter-delete-icon-b64ed4bed3d016eb5abf2af308eba7cf.png";